export default [
  {
    path: "/developer-options/copy-data-tryout",
    name: "copy-data-tryout",
    meta: {
      requireAuth: true,
      pageTitle: "Copy Data Tryout",
      breadcrumb: [
        {
          text: "Developer Options",
          active: false,
        },
        {
          text: "Copy Data Tryout",
          active: true,
        },
      ],
    },
    component: () =>
      import(
        "@/views/dashboard/developer-options/copy-data-tryout/index.vue"
      ),
  },
];
